import {Observable} from 'rxjs';

export abstract class AuthenticationRemote {
  abstract login(username: string, password: string): Observable<any>;
}
